import OrderBasketItem from './OrderBasketItem';

export default {
  OrderBasketItem,
};
